var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGift = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.036 7.494H0V24h23.96v-.007l.04-16.5h-4.175a4.498 4.498 0 0 0 1.117-2.97A4.53 4.53 0 0 0 16.408 0h-.715a4.534 4.534 0 0 0-3.75 1.981A4.534 4.534 0 0 0 8.195 0h-.741a4.531 4.531 0 0 0-4.534 4.523c0 1.136.421 2.176 1.117 2.97Zm12.372 1.551h-3.687v5.95h9.749l.014-5.983h-5.526a4.58 4.58 0 0 1-.55.033Zm6.058 7.494H12.72v5.95h9.73l.015-5.95Zm-11.293-1.545V9.045h-3.72a4.58 4.58 0 0 1-.55-.033h-5.38v5.982h9.65Zm-9.65 1.545h9.65v5.95h-9.65v-5.95Zm9.655-12.427a4.566 4.566 0 0 0-.019.41v2.972H7.005a3.01 3.01 0 0 1-2.564-2.971 3.01 3.01 0 0 1 3.012-3.004h.741a3.013 3.013 0 0 1 2.984 2.593Zm1.532.004a3.013 3.013 0 0 1 2.983-2.59h.715a3.01 3.01 0 0 1 3.012 3.003 3.01 3.01 0 0 1-2.522 2.965h-4.17V4.523c0-.137-.006-.273-.018-.407Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGift);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Gift.a447cfcf9131f08e92018896de40eddc.svg";